import React from "react";
import { ToastState } from "../hooks/useToast";

interface ToastProps {
  toast: ToastState;
}

const Toast: React.FC<ToastProps> = ({ toast }) => {
  if (!toast) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div
        className={`px-4 py-3 rounded-md shadow-lg text-white ${
          toast.type === "success" ? "bg-green-500" : "bg-red-500"
        }`}
      >
        {toast.message}
      </div>
    </div>
  );
};

export default Toast;
